import { ClientNotFoundError } from '../../errors/ClientNotFoundError';
import { getCore } from '../core/getCore';
import type { DynamicClient } from '../types';

let defaultClient: DynamicClient | null = null;
let numOfInitializedClients = 0;

/**
 * Returns the DynamicClient instance that was initialized with createDynamicClient.
 *
 * If more than one instance of DynamicClient was initialized, you should not use this function.
 * Instead, you should pass the client instance you stored to the function that needs it.
 */
export const getDefaultClient = (): DynamicClient => {
  if (!defaultClient) {
    throw new ClientNotFoundError();
  }

  if (numOfInitializedClients > 1) {
    const core = getCore(defaultClient);
    core.logger.debug(
      'Multiple instances of DynamicClient found. If you are only using one client (recommended), make sure you are not calling ' +
        '"createDynamicClient" multiple times. If you are using multiple clients, make sure you are passing which client to use as ' +
        'the last param of all Dynamic functions.'
    );
  }

  return defaultClient;
};

export const setDefaultClient = (client: DynamicClient) => {
  defaultClient = client;
  numOfInitializedClients++;
};
